import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from 'ag-grid-enterprise';

export const agGridLicenseKey =
  'Bright_Computing_Web_CMGUI_2Devs_unlimitedOEM_16_March_2019__MTU1MjY5NDQwMDAwMA==ffb4c5ba74789d7f879c9118f6a4e34e';


LicenseManager.setLicenseKey(agGridLicenseKey);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
